import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query/react';
import { load, save } from 'redux-localstorage-simple';

import application from './application/slice';
import connection from './connection/slice';
import { updateVersion } from './global/actions';
import multicall from './multicall';
import { newsletterApi } from './newsletter/api';
import phonebooth from './phonebooth/slice';
import sound from './sounds/reducer';
import soundMiddleware from './sounds/soundMiddleware';
import { twitterApi } from './twitter/api';
import user from './user/slice';
import wallets from './wallets/slice';

const PERSISTED_KEYS: string[] = ['user'];

const store = configureStore({
  reducer: {
    multicall: multicall.reducer,
    application,
    user,
    wallets,
    connection,
    phonebooth,
    sound,
    [newsletterApi.reducerPath]: newsletterApi.reducer,
    [twitterApi.reducerPath]: twitterApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ thunk: true })
      .concat(newsletterApi.middleware)
      .concat(twitterApi.middleware)
      .concat(soundMiddleware)
      .concat(save({ states: PERSISTED_KEYS, debounce: 1000 })),
  preloadedState: load({ states: PERSISTED_KEYS, disableWarnings: process.env.NODE_ENV === 'test' }),
});

store.dispatch(updateVersion());

setupListeners(store.dispatch);

export default store;

export type AppState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
